var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgExternal28 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 28,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#002D72",
  fillRule: "evenodd",
  d: "M20.962 7.309A.5.5 0 0 0 20.5 7h-7a.5.5 0 0 0 0 1h5.793L7.146 20.146a.5.5 0 0 0 .708.708L20 8.707V14.5a.5.5 0 0 0 1 0V7.497a.5.5 0 0 0-.038-.188Z",
  clipRule: "evenodd"
})));
export { SvgExternal28 as ReactComponent };
export default __webpack_public_path__ + "457c381674eb1e5d5ee084e5bbcc128a.svg";